<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-title>{{ t('UserProfilePage.feedback') }}</ion-title>
        <ion-buttons slot="start">
          <ion-back-button default-href="/profile"></ion-back-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content :fullscreen="true">
      <ion-grid fixed>
        <ion-list v-if="product">
          <ion-list-header color="primary">
            {{ t('product') }}
          </ion-list-header>
          <product-card :product="product" hideDetails="true"></product-card>
        </ion-list>

        <ion-list>
          <ion-list-header color="primary">
            {{ t('FeedbackPage.contactInfo') }}
          </ion-list-header>
          <ion-item>
            <ion-icon :icon="person" slot="start"></ion-icon>
            <ion-label position="stacked">{{ t('FeedbackPage.nickname') }}</ion-label>
            <ion-input :placeholder="t('FeedbackPage.enterNickname')" v-model="name"></ion-input>
          </ion-item>
          <ion-item>
            <ion-icon :icon="mail" slot="start"></ion-icon>
            <ion-label position="stacked">{{ t('FeedbackPage.email') }}</ion-label>
            <ion-input :placeholder="t('FeedbackPage.enterEmail')" type="email" v-model="email"></ion-input>
          </ion-item>
        </ion-list>

        <ion-list>
          <ion-list-header color="primary">
            {{ t('FeedbackPage.feedback') }}
          </ion-list-header>
          <ion-item>
            <ion-icon class="icon-lg" :icon="chatbubbleEllipsesOutline" slot="start"></ion-icon>
            <ion-label position="stacked">{{ t('FeedbackPage.feedback') }}</ion-label>
            <ion-textarea :placeholder="t('FeedbackPage.enterFeedback')" v-model="feedback"></ion-textarea>
          </ion-item>
        </ion-list>

        <ion-button class="submit-btn" expand="block" @click="submitFeedback()">
          {{ t('submit') }}
        </ion-button>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">

// icons
import { mail, person, chatbubbleEllipsesOutline, } from 'ionicons/icons';

// components
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent,
        IonGrid, IonRow, IonButtons, IonButton, IonIcon, IonBackButton,
        IonItem, IonLabel, IonList, IonListHeader,
        IonInput, IonTextarea,
        loadingController, } from '@ionic/vue';
import ProductCard from "@/components/ProductCard.vue";

import { computed, ref } from 'vue';

// services
import CommonService from '@/services/CommonService';

import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { utils } from '@/composables/utils';

export default {
  name: 'FeedbackPage',
  components: { IonPage, IonHeader, IonToolbar, IonTitle, IonContent,
                IonGrid, IonRow, IonButtons, IonButton, IonIcon, IonBackButton,
                IonItem, IonLabel, IonList, IonListHeader,
                IonInput, IonTextarea, ProductCard, },
  setup() {
    const store = useStore();

    const user = computed(() => store.state.user);
    const name = ref(user.value.firstName || "");
    const email = ref(user.value.email || "");
    const feedback = ref("");
    const product = ref<any>(null);

    const route = useRoute();
    const passedProduct: any = route.params.passedProduct; // route paramters (mainly ID)
    if (passedProduct) { // from product detail page (enquiry)
      console.log(passedProduct);
      product.value = JSON.parse(passedProduct);
    } 

    // methods
    const { t } = useI18n();
    const { presentToast } = utils();

    const submitFeedback = async () => {
      const loading = await loadingController.create({});
      await loading.present();
      const res = await CommonService.createNewFeedback(name.value, email.value, feedback.value, product.value);
      loading.dismiss();
      feedback.value = "";
      presentToast( t('FeedbackPage.feedbackSubmitted'), 5000, 'top' );
    }
    
    return {
      // icons
      mail, person, chatbubbleEllipsesOutline,
      
      // variables
      name, email, feedback, product,

      // methods
      t, submitFeedback,
    }
  },
}
</script>

<style scoped>
</style>